import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { GenericEdit } from 'src/app/interfaces/generic-edit';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';



export interface MaliElement {
  available_quantity: string;
  id: number;
  price: number;
  pictures_ids: String[];
  attribute_combinations: Object[];
}



@Component({
    selector: 'meli-variation',
    templateUrl: './meli-variation.component.html',
    styleUrls: ['./meli-variation.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: false
})



export class MeliVariationComponent implements OnInit {

  
  @Input() melidata:Observable<Object>;
  //data:MaliElement[] = [];
  dataSource:MaliElement[] = [];
  columnsToDisplay:Map<string,string> =  new Map();

  eventsSubscription: Subscription;
  columns:string[] = [];
  expandedElement: MaliElement;
  dataLoaded = false;
  constructor() { }

  ngOnInit(): void {
    
    this.columnsToDisplay.set('id','Id. Variação');
    this.columnsToDisplay.set('price','Preço');
    this.columnsToDisplay.set('available_quantity','Quantidade');
    
    this.columnsToDisplay.forEach((value: string, key: string, map:Map<string,string>) => {
      this.columns.push(key)
    });
    
  }

  ngOnChanges(){

      if ( !this.dataLoaded ){
        if ( this.melidata != null){
          this.dataSource = this.melidata['variations'];
          this.dataLoaded = true;
        }
      }
  }

  getLinkImage(image):string{

    let r:string = "../assets/image/no-image-icon.png";

    if ( ObjectUtil.isNotEmpty(this.melidata['pictures'])){
        let pic:Object[] = this.melidata['pictures'];
        pic.forEach( data=>{
            if ( data['id'] == image ){
              r = data['url'];
            }
        })
    }
    return r;
  }
}
